import { connect } from 'react-redux';
import { downloadCsv } from 'src/reducers/reports/reportHealthInsuranceBonus';
import CsvModalForm from '../../components/Modal/CsvModalForm';

const initialValues = { paymentFor: 'pension_office' };
const mapStateToProps = () => ({
  initialValues
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: data => {
    dispatch(downloadCsv(data, ownProps.bonusId, ownProps.hideModal));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CsvModalForm);
